module.exports = __webpack_public_path__ + "img/type_dolly.8addf974.jpg";